import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { SubSink } from 'subsink';

import {
  AuthenticationActions,
  AuthenticationSelectors,
} from '@authentication/store/authentication.slice';
import { ApiErrorResponse } from '@shared/interfaces/api-error-response';

@Component({
  selector: 'app-partner-user-registration',
  templateUrl: './partner-user-registration.component.html',
  styleUrls: ['./partner-user-registration.component.scss'],
})
export class PartnerUserRegistrationComponent implements OnInit, OnDestroy {
  merchantId?: string;

  merchantId$: Observable<string> = this.store.select(
    AuthenticationSelectors.selectMerchantId
  );

  isLoading$: Observable<boolean> = this.store.select(
    AuthenticationSelectors.selectIsLoading
  );

  private _errorResponse$: Observable<ApiErrorResponse | undefined> =
    this.store.select(
      AuthenticationSelectors.selectMerchantUserRegistrationErrorResponse
    );
  public get errorResponse$(): Observable<ApiErrorResponse | undefined> {
    return this._errorResponse$;
  }
  public set errorResponse$(value: Observable<ApiErrorResponse | undefined>) {
    this._errorResponse$ = value;
  }

  private subs = new SubSink();

  constructor(private store: Store, private router: Router) {}

  ngOnInit(): void {
    this.subs.sink = this.merchantId$.subscribe((merchantId) => {
      if (!merchantId) {
        this.router.navigate(['/telesales/partner-registration'], {
          replaceUrl: true,
        });
      } else {
        this.merchantId = merchantId;
      }
    });
  }

  onContinue(formValue: any): void {
    this.store.dispatch(
      AuthenticationActions.registerMerchantUserByTelesales.trigger({
        user: formValue,
      })
    );
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }
}
